import PullRequestLink from './pull-request-link';

export { OwnProps as PullRequestLinkProps } from './pull-request-link';
// eslint-disable-next-line import/no-default-export
export default PullRequestLink;
